
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';

export interface CalendarEventInterface {
  name: string,
  userId: string
  start: Date,
  end: Date,
  color: string,
  timed: boolean
  details: string;
}

@Component({
  mixins: [
    Themeable,
  ],
})
export default class CalendarComponent extends Vue {
  @Prop() private events!: CalendarEventInterface[];
  @Prop() private title!: string;
  private type: string = 'month';
  private mode: string = 'stack';
  private weekdays: number[] = [1, 2, 3, 4, 5, 6, 0];

  private value: Date = new Date();

  private selectedEvent: CalendarEventInterface = {} as CalendarEventInterface;
  private selectedElement: EventTarget | null = null;
  private selectedOpen: boolean = false;

  @Watch('value')
  private monthChanged(): void {
    this.$emit('date-changed', this.value);
  }

  private showLeave(data: { nativeEvent: PointerEvent, event: CalendarEventInterface }): void {
    const open = () => {
      this.selectedEvent = data.event;
      this.selectedElement = data.nativeEvent.target;
      requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true));
    };

    if (this.selectedOpen) {
      this.selectedOpen = false;
      requestAnimationFrame(() => requestAnimationFrame(() => open()));
    } else {
      open();
    }

    data.nativeEvent.stopPropagation();
  }

  private async viewUserLeaves(event: CalendarEventInterface): Promise<void> {
    await this.$router.push({ name: 'employee_leaves', params: { userId: event.userId } });
  }
}
